import { N500, R300 } from '@atlaskit/theme/colors';
/* Maximum value for app rating */
export const TOTAL_STARS = 4;
export const FULL_STAR = 'fullStar';
export const EMPTY_STAR = 'emptyStar';
export const QUARTER_STAR = 'quarterStar';
export const HALF_STAR = 'halfStar';
export const THREE_QUARTER_STAR = 'threeQuarterStar';
export const NO_RATING_STAR = 'noRatingStar';

/* Design token configuration for Star Ratings*/
export const STAR_FILL_MAP = {
  [FULL_STAR]: {
    fill: "var(--ds-icon-accent-orange, ".concat(R300, ")")
  },
  [EMPTY_STAR]: {
    fill: "var(--ds-background-accent-gray-subtle, ".concat(N500, ")")
  },
  [QUARTER_STAR]: {
    fill: "url(#".concat(QUARTER_STAR, ")")
  },
  [HALF_STAR]: {
    fill: "url(#".concat(HALF_STAR, ")")
  },
  [THREE_QUARTER_STAR]: {
    fill: "url(#".concat(THREE_QUARTER_STAR, ")")
  },
  [NO_RATING_STAR]: {
    fill: "var(--ds-background-accent-gray-subtlest-pressed, #B3B9C4)"
  }
};